import React from 'react';
import './AboutSection.css';
import aboutImage from '../images/about.jpg';

function AboutSection() {
    return (
        <section className="about-section" id="about">
            <div className="about-content">
                {/* LEFT COLUMN: TEXT */}
                <div className="about-text">
                    <h1>Antiquités Stéphane Weinrich : Expert en Objets Anciens, Bijoux et Mobilier d'Époque</h1>
                    <p>
                        <strong>Bienvenue chez Stéphane Weinrich</strong>, antiquaire passionné et expérimenté, spécialisé dans l'achat, la vente et l'expertise d'objets anciens.
                    </p>
                    <p>
                        Je suis <strong>Stéphane Weinrich</strong>, antiquaire de métier, et je perpétue avec fierté une tradition familiale qui s'étend sur trois générations. Depuis 1975, grâce à l'impulsion de mon grand-père, je me consacre avec passion à l'univers des antiquités. Cette belle aventure, transmise de père en fils, repose sur des valeurs essentielles : la confiance, la transparence et une expertise reconnue dans le domaine des antiquités.
                    </p>

                    <h2>Une Expertise Inégalée en Antiquités</h2>
                    <p>
                        En tant qu'antiquaire professionnel, je suis spécialisé dans l'acquisition et l'évaluation de divers trésors, notamment :
                        <ul>
                            <li><strong>Objets anciens</strong> : vaisselle, sculptures, œuvres d'art, et autres pièces rares.</li>
                            <li><strong>Mobilier d'époque</strong> : commodes, buffets, tables, fauteuils et autres meubles anciens.</li>
                            <li><strong>Bijoux précieux</strong> : bagues, colliers, bracelets et montres vintage.</li>
                            <li><strong>Numismatique</strong> : pièces de monnaie anciennes et médailles rares.</li>
                            <li><strong>Objets de collection</strong> : livres anciens, instruments de musique, jouets d'époque, et bien plus.</li>
                        </ul>
                        Chaque objet est unique, et mon expertise me permet d'identifier avec précision leur authenticité, leur histoire et leur valeur marchande.
                    </p>

                    <h2>Services Offerts par un Antiquaire de Confiance</h2>
                    <p>
                        Mon objectif principal est de vous offrir un service complet et adapté à vos besoins. Voici ce que je propose :
                        <ul>
                            <li><strong>Expertise gratuite</strong> : j'évalue gratuitement vos objets, sans engagement.</li>
                            <li><strong>Achat immédiat</strong> : je procède à l'achat direct de vos objets, avec un règlement sur place pour un maximum de simplicité.</li>
                            <li><strong>Déplacement à domicile</strong> : je viens directement chez vous pour réaliser les évaluations, garantissant un service rapide, discret et efficace.</li>
                            <li><strong>Conseils personnalisés</strong> : je vous accompagne pour mieux comprendre la valeur de vos biens et prendre les meilleures décisions.</li>
                        </ul>
                        Avec une approche professionnelle et bienveillante, je m'assure que chaque client bénéficie d'une expérience transparente et sans stress.
                    </p>

                    <h2>Pourquoi Choisir Stéphane Weinrich comme Antiquaire ?</h2>
                    <p>
                        Faire appel à mes services, c'est choisir :
                        <ul>
                            <li><strong>Une tradition et une expertise reconnues</strong> : trois générations d'expérience dans le domaine des antiquités.</li>
                            <li><strong>La transparence</strong> : chaque étape du processus est claire et expliquée en détail.</li>
                            <li><strong>La confiance</strong> : je respecte vos objets et vos attentes, en garantissant un service de qualité.</li>
                            <li><strong>Une évaluation précise</strong> : qu'il s'agisse d'une pièce rare ou d'un bien plus commun, mon expertise assure une estimation fiable.</li>
                        </ul>
                    </p>

                    <h2>Contactez-moi pour une Évaluation Immédiate</h2>
                    <p>
                        Vous souhaitez vendre vos objets anciens, bijoux ou mobilier d'époque ? Je suis à votre disposition pour vous accompagner dans cette démarche. N'hésitez pas à me contacter pour une expertise gratuite ou pour discuter de vos besoins. Ensemble, nous valoriserons vos trésors dans le respect de leur histoire et de leur authenticité.
                    </p>

                    <a href="/objets" className="cta-button">Quels objets rachetons-nous ?</a>
                </div>

                {/* RIGHT COLUMN: IMAGES (STICKY) */}
                <div className="about-images">
                    <div className="about-image">
                        <img src={aboutImage} alt="Boutique d'antiquités Stéphane Weinrich" />
                    </div>
                    <div className="about-image">
                        <img src={aboutImage} alt="Objets d'art et antiquités rares" />
                    </div>
                    <div className="about-image">
                        <img src={aboutImage} alt="Mobilier d'époque et objets anciens" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutSection;
